// "use strict";
import { OLabApiQuestion } from "./OLabApiQuestion";

export class OLabApiSliderQuestion extends OLabApiQuestion {
  constructor(clientApi, id) {
    super(clientApi, id);
  }
}
